'use client';

import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { ITheme } from '../../themer';
import { ContentWrap } from '../Layout';
import {
	IHeaderParentTitleProps,
	HeaderParentTitle,
} from './HeaderParentTitle';
import { StyledHeaderTitle } from './StyledHeaderTitle';
import { IStyledHeaderProps } from './IStyledHeaderProps';
import { getBackgroundColor, getTextColor } from './helpers';

export interface IHeaderProps extends IHeaderParentTitleProps {
	title?: string;
	className?: string;
	children?: ReactNode;
}

const StyledHeader = styled.div<IStyledHeaderProps, ITheme>`
	background: ${getBackgroundColor};
	color: ${getTextColor};
`;

export function Header({
	title,
	parentTitle,
	parentUrl,
	inverted,
	className,
	children,
}: IHeaderProps) {
	return (
		<StyledHeader className={className}>
			<ContentWrap>
				<HeaderParentTitle
					parentTitle={parentTitle}
					parentUrl={parentUrl}
					inverted={inverted}
				/>
				{title && (
					<StyledHeaderTitle inverted={inverted}>{title}</StyledHeaderTitle>
				)}
				{children}
			</ContentWrap>
		</StyledHeader>
	);
}
